import { MutationTree } from 'vuex';
import { State } from './state';
import { SET_USER_TYPE_LIST,
         SET_SELECTED_USER_TYPE,
         ADD_USER_TYPE_TO_LIST,
         SET_USER_FORM_VISIBILITY,
        } from './types';
import { IUserType } from '../models';


export const mutations: MutationTree<State> = {
   [SET_USER_TYPE_LIST](state: State, payload: IUserType[]) {
       state.userTypes = payload;
   },
   [SET_SELECTED_USER_TYPE](state: State, payload: IUserType) {
       state.userTypeSelected = payload;
   },
   [ADD_USER_TYPE_TO_LIST](state: State, payload: IUserType) {
       state.userTypes.push(payload);
   },
   [SET_USER_FORM_VISIBILITY](state: State, payload: boolean) {
       state.showRegisterForm = payload;
   },
};
